module.exports = __webpack_public_path__ + "img/5.72c742ba.png";